<template>
  <v-app>
    <component v-bind:is="layout"></component>
  </v-app>
</template>
<script>
export default {
  components: {
    CoreLayout: () => import('@/layouts/CoreLayout'),
    BlankLayout: () => import('@/layouts/BlankLayout')
  },
  computed: {
    layout () {
      return this.$store.getters.layout
    }
  },
  created: function () {
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(() => {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          sessionStorage.removeItem('accessToken')
          this.$router.push('/login')
        }
        throw err
      })
    })
  }
}
</script>

<style lang="scss">
.v-table-card {
  width: 100% !important;
}
.v-data-table {
  width: 100% !important;
  td {
    padding: 15px !important;
  }
}
</style>